


import React from 'react';
import '../../styles/Services.css';

const serviceData = [
    {
        icon: 'ri-apps-line',
        title:  'Web Development',
        desc: 'Need a website that offers a seamless user experience and good performance? We are here to help this effort go smoothly by offering a ledger.'
    },

    {
        icon: 'ri-quill-pen-line',
        title:  'Graphic Design',
        desc: 'For all works related to flyers, business cards, logo, mock-ups, banners, book covers, do contact us.'
    },

    {
        icon: 'ri-live-line', 
        title:  'Video Editing',
        desc: 'We provide services in whiteboard animations, promotional videos, advertisement videos, YouTube videos, among others.'
    },

    {
        icon: 'ri-lightbulb-line',  
        title:  'Content writing',
        desc: 'We offer the necessary assistance to improve scalability in oder to improve your business operations, by giving you the right content to feed your target audience'
    },
];

const Services = () => {
    return <section id="services">
      <div className="container">
        <div className="service_top-content">
        <h2 className="ps">Our
                    <span className="highlight"> Services</span>
                </h2>
            <h2>We use upper edge methods to help with whatever you might require for graphic design, video editing, web development, and 
                content and copywriting
            </h2>
            
        </div>

        <div className="service_item-wrapper">
            {
                serviceData.map((item,index)=> (
                    <div className="services_item" key={index}>
                        <span className="service_icon">
                            <i class={item.icon}></i>
                        </span>
                        <h3 className="service_title">{item.title}</h3>
                        <p className="description">
                            {item.desc}
                        </p>
                        </div>
                ))
            }
        </div>
      </div>
    </section>
    
};

export default Services;